import { cn } from "@/lib/cn";
import { Logomark } from "./Logomark";
import { Wordmark } from "./Wordmark";

const SIZE_MAP = {
  sm: { mark: "sm", word: "sm", gap: "gap-1.5" },
  md: { mark: "md", word: "md", gap: "gap-2" },
  lg: { mark: "lg", word: "lg", gap: "gap-3" },
} as const;

/**
 * DESIGN.md §2.3: mark sits slightly taller than the wordmark's cap height,
 * bottom-aligned, with a gap of roughly 3/8 of the mark height.
 */
export function LogoHorizontal({ size = "md", className }: { size?: keyof typeof SIZE_MAP; className?: string }) {
  const { mark, word, gap } = SIZE_MAP[size];
  return (
    <span className={cn("inline-flex items-center", gap, className)}>
      <Logomark size={mark} />
      <Wordmark size={word} />
    </span>
  );
}
